import { render, staticRenderFns } from "./commentModal.vue?vue&type=template&id=ff18e000&"
import script from "./commentModal.vue?vue&type=script&lang=js&"
export * from "./commentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports